<template>
    <div>
      <router-view></router-view>
    </div>
  </template>
  
  <script>
  export default {
    name: "ReviewsLayout"
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/home/reviews/ReviewsLayout.vue